import StreamService from "@/services/stream";
import CollectionService from "@/services/collection"

import productCard from "@/components/productcard"
import trackCard from "@/components/trackcard"
import contentTopHeader from "@/components/contentTopHeader"

import repostMusic from "./repostMusic"
import repostVideos from "./repostVideos"
import repostProducts from "./repostProducts"
import CollectionPlaylist from '@/services/collection_playlist'

export default {
    components: {
        productCard,
        trackCard,
        contentTopHeader,
        repostMusic,
        repostVideos,
        repostProducts,
    },
    data() {
        return {
            activeTab: "music",
            tabs: [
                { id: "music", title: "Music" },
                { id: "videos", title: "Videos" },
                { id: "products", title: "Products" },
            ],
            tracks: null,
            streams: null,
            products: null,
            pageReady: false,
            playlist_data: null,
            playlistTracks: null,
            playlistStreams: null,
            viewAllPlaylist: false,
            show_delete_playlist_modal: false,
            playlist_id: null,
        }
    },
    computed: {
        playlists() {
            return this.$store.state.playlist.playlists
        },

        currentUser() {
            return this.$store.state.auth.user
        },
    },

    mounted() {
        this.$parent.$el.classList.add("loading")
    },

    methods: {
      methodThatForcesUpdate() {
          this.$parent.$el.classList.add("loading")
          this.getCollectionPlaylist()
          this.loadData()
          this.$parent.$el.classList.remove("loading")
      },

      onTab(tab) {
          this.activeTab = tab
      },

      isActiveTab(tab) {
          return this.activeTab === tab
      },

      getStream() {
            const vid_params = {
                genre_id: 0,
                only_follows: false,
                page: 1,
                per_page: 10,
            };
            StreamService.getStreams(vid_params)
                .then((response) => {
                    this.videos = response.body.streams;
                })
                .catch((error) => {
                    this.$store.dispatch("error/showErrorToast", [error]);
                });
      },
        
      getCollections() {
        CollectionService.getCollections().then(response => {
          this.$parent.$el.classList.remove('bg-light')
          this.$parent.$el.classList.add('bg-grey')
          this.tracks = response.body.tracks
          this.streams = response.body.streams
          this.products = response.body.products
          this.pageReady = true
          this.$parent.$el.classList.remove("loading")
        }).catch(exception => {
          this.$store.dispatch("error/showErrorToast", [exception.body.error] || [exception] );
        })
      },

      async loadData() {
            await CollectionService.getCollections().then(response => {
              this.$parent.$el.classList.remove('bg-light')
              this.$parent.$el.classList.add('bg-grey')
              this.tracks = response.body.tracks
              this.streams = response.body.streams
              this.products = response.body.products
              this.pageReady = true
              this.$parent.$el.classList.remove("loading")
            }).catch(exception => {
              this.$store.dispatch("error/showErrorToast", [exception.body.error] || [exception] );
            })
      },

      async getCollectionPlaylist() {
            await CollectionPlaylist.getCollectionPlaylists()
            .then((response) => {
                this.playlist_data = response.body
            })
            .catch((e) => {
                this.$store.dispatch(
                'error/showErrorToast',
                e.body.errors || [e.body]
                )
            })
      },

      openDeletePlaylistModal(playlistId) {
        this.show_delete_playlist_modal = true
        this.playlist_id = playlistId
      },

      deletePlaylist() {
        CollectionPlaylist.destroy(this.playlist_id)
          .then(response => {
            this.$store.dispatch('error/showSuccessToast', [
              response.bodyText,
            ])
            this.show_delete_playlist_modal = false
            this.getCollectionPlaylist()
          })
          .carch(e => {
            this.$store.dispatch('error/showErrorToast', [
              'Unable to remove playlist from collection',
            ])
            this.show_delete_playlist_modal = false
          })
      },
    },

    async created() {
        await this.getCollectionPlaylist()
        await this.loadData()
        if (this.$route.params.activeTab !== undefined) {
            this.activeTab = this.$route.params.activeTab
        }
    },
}


// WEBPACK FOOTER //
// ./src/views/collection/index.ctrl.js